export const EVALUATION_MODULE = 'evaluation';
